//
//
//
//
//
//
//
//
//
//
//
//
//

// import MrHeader from '@/components/Header'
// import mrFooter from '@/components/Footer'
export default {
  name: 'app',
  components: {
    // MrHeader,
    // mrFooter
  }
}



// WEBPACK FOOTER //
// ./src/App.vue